import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ToastService} from 'bs-components';

@Injectable({
  providedIn: 'root',
})
export class MessageHandlerService {
  private readonly toastService = inject(ToastService);


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      if (error.status === 503) {
        this.log('error', `${operation} - Server not available`, 3);
      } else {
        this.log(
          'error',
          `${operation} - ${error.error?.description}`,
          3
        );
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  public log(title: string, content: string, level: number) {
    switch (level) {
      case 0:
        this.toastService.showInfo(title, content);
        break;
      case 1:
        this.toastService.showSuccess(title, content);
        break;
      case 2:
        this.toastService.showWarning(title, content);
        break;
      case 3:
        this.toastService.showError(title, content);
        break;
    }
  }
}
